document.addEventListener("DOMContentLoaded", function () {
  // Highlight the "unlocked" pricing tier for bulk buying

  //   PDP quantity selector
  const quantityInput = document.querySelector(
    ".product-details .quantity__input"
  );
  if (!quantityInput) return;

  function getTier(quantity, t) {
    if (!t[0]) return null;
    if (t[3] && quantity >= t[3]) return 4;
    if (t[2] && quantity >= t[2]) return 3;
    if (t[1] && quantity >= t[1]) return 2;
    if (t[0] && quantity >= t[0]) return 1;
    if (t[0] && quantity >= 1 && quantity < t[0]) return 0;
    return null;
  }

  //   Update on quantity change
  function updateUnlockedLabel() {
    const quantity = parseInt(quantityInput.value, 10);
    if (isNaN(quantity)) return;

    // Read tier quantities from the checked variant's .label-bulk-order data attributes
    const checkedRadio = document.querySelector(".variant-radio:checked");
    const picker =
      checkedRadio?.closest(".field")?.querySelector(".label-bulk-order") ??
      document.querySelector(".label-bulk-order");
    if (!picker) return;

    const t = [
      picker.getAttribute("data-tier-1"),
      picker.getAttribute("data-tier-2"),
      picker.getAttribute("data-tier-3"),
      picker.getAttribute("data-tier-4"),
    ].map((v) => (v !== null && v !== "" ? parseInt(v, 10) : null));

    const tier = getTier(quantity, t);

    // Remove unlocked class from all
    document.querySelectorAll(".label--wrapper").forEach((el) => {
      el.classList.remove("label-unlocked-price");
    });

    // Only add unlocked class to the label for the selected variant and correct tier
    if (tier !== null && checkedRadio) {
      // Find the closest .field for the checked radio
      const field = checkedRadio.closest(".field");
      if (field) {
        // Find the label--wrapper for this field and tier
        const label = field.querySelector(".label--wrapper-tier-" + tier);
        if (label) label.classList.add("label-unlocked-price");
      }
    }
  }

  quantityInput.addEventListener("input", function () {
    updateUnlockedLabel();
  });
  quantityInput.addEventListener("change", function () {
    updateUnlockedLabel();
  });

  // Also update when a variant is selected
  document.querySelectorAll(".variant-radio").forEach((radio) => {
    radio.addEventListener("change", function () {
      updateUnlockedLabel();
    });
  });

  updateUnlockedLabel();
});
